import { Directive, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

import { InputDirective } from './input.directive';
import { TT_INPUT_HOST } from './tt-input.token';

@Directive({
  selector: 'input[ttInputControl]',
  standalone: true,
})
export class InputControlDirective {
  private control = inject(NgControl);
  private host = inject(TT_INPUT_HOST, { optional: true }) as InputDirective | null;

  constructor() {
    this.host?.registerNgControl(this.control);
  }
}
